<template>
  <div>正在跳转。。。。。</div>
</template>

<script>
  import Vue from 'vue'
  import SSO from '@/oauth/sso.js'
  export default {
    name: "oauth",
    data() {
      return {
      }
    },
    beforeCreate () {
      SSO.init(() => {
        this.loginSuccess();
      });
    },
    methods: {
      loginSuccess () {
        // update-begin- author:sunjianlei --- date:20190812 --- for: 登录成功后不解除禁用按钮，防止多次点击
        // this.loginBtn = false
        // update-end- author:sunjianlei --- date:20190812 --- for: 登录成功后不解除禁用按钮，防止多次点击
        this.$router.push({ path: "/dashboard/analysis" })
        this.$notification.success({
          message: this.$t('systemBase.welcome'),
          description: `${timeFix(this)}，` + this.$t('systemBase.welcomeBack'),
        });
      },
    }
  }
</script>

